import {
  CREATE_RADIO_BILLING,
  DELETE_RADIO_BILLING,
  EDIT_RADIO_BILLING,
  RECEIVE_RADIO_BILLINGS,
  REQUEST_RADIO_BILLING,
  REQUEST_RADIO_BILLING_FOR_RADIO,
} from '@sophocles/entities/RadioBilling/radioBillingActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RADIO_BILLINGS: // Read
      return state.merge(action.radioBillings);
    case DELETE_RADIO_BILLING: // Delete
      return state.delete(action.radioBilling.toString());
    case EDIT_RADIO_BILLING: // Update
    case CREATE_RADIO_BILLING: // Create
    case REQUEST_RADIO_BILLING:
    case REQUEST_RADIO_BILLING_FOR_RADIO:
    default:
      return state;
  }
}

export function radioBillingReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RADIO_BILLING:
    case DELETE_RADIO_BILLING:
    case RECEIVE_RADIO_BILLINGS:
    case EDIT_RADIO_BILLING:
    case REQUEST_RADIO_BILLING:
    case REQUEST_RADIO_BILLING_FOR_RADIO:
      return getState(state, action);
    default:
      return state;
  }
}
